import { JobStatus, Report } from '@/api/generatedApi';
import { useReportPolling } from '@/hooks/useDataPolling/useReportPolling';
import { Box, LinearProgress, Typography } from '@mui/material';

export const ReportStatusCell = ({ row }: { row: Report }) => {
  const { data: report } = useReportPolling({ row });

  const status = report.status;
  const progress = report.progress || 0;
  const isInProgress = status === JobStatus.RUNNING;
  const isPending = status === JobStatus.PENDING;

  const getStatusText = () => {
    switch (status) {
      case JobStatus.PENDING: {
        return 'Pending';
      }
      case JobStatus.RUNNING: {
        return `In Progress (${Math.round(progress)}%)`;
      }
      case JobStatus.COMPLETED: {
        return 'Completed';
      }
      case JobStatus.FAILED: {
        return 'Failed';
      }
      default: {
        return status;
      }
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
      <Typography variant='body2'>{getStatusText()}</Typography>
      {isPending && (
        <LinearProgress
          sx={{
            mt: 0.5,
            height: 6,
            borderRadius: 3,
            backgroundColor: 'grey.300',
            '& .MuiLinearProgress-bar': {
              borderRadius: 3,
              backgroundColor: 'secondary.main',
            },
          }}
        />
      )}
      {isInProgress && (
        <LinearProgress
          variant='determinate'
          value={progress}
          sx={{
            mt: 0.5,
            height: 6,
            borderRadius: 3,
            backgroundColor: 'grey.300',
            '& .MuiLinearProgress-bar': {
              borderRadius: 3,
              backgroundColor: 'secondary.main',
            },
          }}
        />
      )}
    </Box>
  );
};
